// 引入Vue
import Vue from 'vue'
// 引入路由
import VueRouter from 'vue-router'
// 使用插件
Vue.use(VueRouter)

// import lhUIChildrenRoutes from '../views/lhUI/routes/index'
import homeChildrenRoutes from "../views/home/routes/index"

// 创建并暴露一个路由
export default new VueRouter({
  routes:[
    {
      path:'/',
      beforeEnter:(to,from,next)=>{
        let user=JSON.parse(localStorage.getItem("user"));
        if(user==null){
          next("/login");
        }else{
          next();
        }
      },
      component: ()=>import("../views/home/Index.vue"),
      children:homeChildrenRoutes
    },
    {
      path:"/login",
      component: ()=>import("../views/home/Login.vue")
    }
    // {
    //   path:'/lhUI',
    //   component: ()=>import("../views/lhUI/Index.vue"),
    //   redirect: '/install',
    //   children:lhUIChildrenRoutes
    // },
    // {
    //   path:"/mpimDownload",
    //   component:()=>import("../views/mpim/Index.vue"),
    //   meta:{
    //     title:"摩斯输入法"
    //   }
    // }
  ]
})